export enum MaintenanceObjectListConfig {
  PickingList,
  PendingList
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/enums/MaintenanceObjectListConfig.ts